<script>
    import { url, isActive } from "@roxi/routify";
    import { replacePortUrl } from "../js/utils";
    import { format } from 'svelte-i18n';

    let { routes = [] } = $props();
</script>

<ol class="breadcrumb float-end no-export">
    {#each [{path: '/', label: $format("components.breadcrumb.home")}, ...routes] as route}
        <li class="breadcrumb-item" class:active={route.path ? $isActive(route.path) : true}>
            {#if route.path}
                <a href="{$url(replacePortUrl(route.path))}">{route.label}</a>
            {:else}
                {route.label}
            {/if}
        </li>
    {/each}
</ol>